import { useContent } from '../../../../hooks/use-server-content';

export interface CaoProps {
    hide: boolean;
    bannerTitle: string;
    bannerDescription: string;
    caoBackgroundImageDesktop: string;
    caoBackgroundImageMobile: string;
}
export const useCaoContent = (): CaoProps | null => {
    const [content, getValueByName] = useContent('common', 'cao-banner');
    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide) {
            contentFragment = null;
        }
    }
    return contentFragment as CaoProps;
};
